var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 52C40.3594 52 52 40.3594 52 26C52 11.6406 40.3594 0 26 0C11.6406 0 0 11.6406 0 26C0 40.3594 11.6406 52 26 52Z",
    fill: "url(#paint0_linear_5879_6384)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5879_6384)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7574 27.8301C23.8676 28.9773 24.0543 29.8299 24.3113 30.3924C24.5715 30.9531 25.0334 31.2328 25.7001 31.2328C25.8248 31.2328 25.9363 31.2133 26.0469 31.1907C26.1602 31.2133 26.2713 31.2328 26.3968 31.2328C27.0618 31.2328 27.525 30.9531 27.7838 30.3924C28.0422 29.8299 28.2258 28.9773 28.3382 27.8301L28.9302 18.9722C29.0403 17.2457 29.0965 16.0069 29.0965 15.2549C29.0965 14.2315 28.8295 13.4328 28.2938 12.8594C27.7562 12.286 27.05 12 26.1752 12C26.1285 12 26.0936 12.0104 26.0478 12.0122C26.0043 12.0104 25.9685 12 25.9232 12C25.0465 12 24.3417 12.286 23.805 12.8594C23.2688 13.4337 23 14.2328 23 15.2554C23 16.0074 23.0548 17.2462 23.1668 18.9727L23.7574 27.8301",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0691 34.4705C25.2197 34.4705 24.4981 34.7384 23.8988 35.2742C23.3001 35.8104 23 36.4613 23 37.2255C23 38.0881 23.3037 38.7671 23.9065 39.2602C24.5121 39.7534 25.2183 40 26.0256 40C26.8474 40 27.564 39.757 28.1768 39.2698C28.7887 38.7839 29.0947 38.1012 29.0947 37.2264C29.0947 36.4622 28.8019 35.8113 28.2163 35.2751C27.6306 34.7384 26.9149 34.4705 26.0677 34.4705",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5879_6384",
    x: 19,
    y: 12,
    width: 14.0957,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5879_6384"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5879_6384",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5879_6384",
    x1: 4.0626,
    y1: -4.10822,
    x2: 63.3116,
    y2: 51.4394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA2A3D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/error-circle.2dc9d9f5a6f87aa0a96756dce2b88daa.svg";
export { ForwardRef as ReactComponent };